import * as React from "react";

;
export const AssetActionAdd = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}><path fill="#100722" d="M12.75 24V0h-1.5v11.25H0v1.5h11.25V24h1.5ZM24 12.75h-9.76v-1.5H24v1.5Z" /></svg>;